export const INITIALLINK = window.location.href
